<template>
    <div>
        <v-row>
            <v-col cols="6">
                <h1 class="headline font-weight-light mb-3">
                    OT

                    <span v-if="data_main.length != 0">{{
                        " - " + data_main.paycode
                    }}</span>
                </h1>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="6" class="text-right" v-if="team_name == 'HR'">
                <v-btn
                    fab
                    small
                    :color="chk_export_data == false ? 'green accent-3' : ''"
                    :disabled="chk_export_data == true"
                    class="mr-1 mt-2"
                    @click="export_data()"
                >
                    <v-icon
                        v-if="chk_export_data == false"
                        color="teal darken-4"
                        >mdi-file-excel</v-icon
                    >
                    <img
                        v-if="chk_export_data == true"
                        src="../../assets/all/Loading.gif"
                        style="width:6%; "
                    />
                </v-btn>
            </v-col>
        </v-row>

        <!-- START MAIN -->
        <v-row v-if="data_main.length == 0">
            <v-col cols="12">
                <v-progress-linear
                    indeterminate
                    color="orange accent-4"
                ></v-progress-linear>
            </v-col>
        </v-row>
        <div v-for="(row, index) in data_main.zone" :key="index">
            <v-row class="fix-h-province">
                <v-col cols="6">{{ row.tl_name }} </v-col>
                <v-col cols="6" class="text-right">
                    <span class="subheading mr-2 fix-font-1ea">
                        Total CE {{ row.total }}
                    </span>
                    <span class="mr-1 fix-font-ea">·</span>
                    <span class="subheading mr-2 fix-font-2ea">
                        Pending {{ row.pending }}
                    </span>
                    <span class="mr-1 fix-font-ea">·</span>
                    <span class="subheading fix-font-3ea">
                        Approved {{ row.approved }}
                    </span>
                </v-col>
            </v-row>
            <v-card>
                <v-row>
                    <v-col cols="12">
                        <v-simple-table class="table-inv">
                            <template v-slot:default>
                                <thead>
                                    <tr class="col-tr-1">
                                        <th class="text-center">#</th>
                                        <th class="text-center">Name</th>
                                        <th class="text-center">
                                            Summary OT (Hrs.)
                                        </th>
                                        <th class="text-center">
                                            Approve Status
                                        </th>
                                        <th class="text-center">
                                            Log / Print
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(rowCe, num) in row.engineer"
                                        :key="num"
                                    >
                                        <td class="text-center">
                                            {{ num + 1 }}.
                                        </td>
                                        <td>
                                            <v-btn
                                                small
                                                text
                                                class="btn-detail2"
                                                @click="
                                                    view_emp(
                                                        rowCe.emp_id,
                                                        rowCe.emp_name_en,
                                                        rowCe.emp_surname_en
                                                    )
                                                "
                                                >{{
                                                    rowCe.emp_name_en +
                                                        " " +
                                                        rowCe.emp_surname_en
                                                }}</v-btn
                                            >
                                        </td>
                                        <td class="text-center">
                                            <v-btn-toggle rounded>
                                                <v-tooltip top>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                        }"
                                                    >
                                                        <v-btn
                                                            small
                                                            v-on="on"
                                                            color="blue darken-4 amber--text"
                                                        >
                                                            x1.0 :
                                                            {{ rowCe.x10 }}
                                                        </v-btn>
                                                    </template>
                                                    <span>x1.0</span>
                                                </v-tooltip>

                                                <v-tooltip top>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                        }"
                                                    >
                                                        <v-btn
                                                            small
                                                            v-on="on"
                                                            color="blue darken-4 amber--text"
                                                        >
                                                            x1.5 :
                                                            {{ rowCe.x15 }}
                                                        </v-btn>
                                                    </template>
                                                    <span>x1.5</span>
                                                </v-tooltip>

                                                <v-tooltip top>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                        }"
                                                    >
                                                        <v-btn
                                                            small
                                                            v-on="on"
                                                            color="blue darken-4 amber--text"
                                                        >
                                                            x3.0 :
                                                            {{ rowCe.x30 }}
                                                        </v-btn>
                                                    </template>
                                                    <span>x3.0</span>
                                                </v-tooltip>
                                            </v-btn-toggle>
                                        </td>
                                        <td class="text-center">
                                            <v-btn-toggle rounded>
                                                <v-tooltip top>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                        }"
                                                    >
                                                        <v-btn
                                                            small
                                                            v-on="on"
                                                            :color="
                                                                rowCe
                                                                    .approve_status
                                                                    .requested_status ===
                                                                'not approve'
                                                                    ? 'yellow darken-1 white--text '
                                                                    : rowCe
                                                                          .approve_status
                                                                          .requested_status ===
                                                                      null
                                                                    ? 'blue-grey darken-2 white--text'
                                                                    : 'green accent-3 white--text'
                                                            "
                                                        >
                                                            CE
                                                        </v-btn>
                                                    </template>
                                                    <span>{{
                                                        rowCe.approve_status
                                                            .requested_date
                                                    }}</span>
                                                </v-tooltip>

                                                <v-tooltip top>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                        }"
                                                    >
                                                        <v-btn
                                                            small
                                                            v-on="on"
                                                            :color="
                                                                chk_approve_color(
                                                                    rowCe
                                                                        .approve_status
                                                                        .requested_status,
                                                                    1,
                                                                    rowCe
                                                                        .approve_status
                                                                        .head_status
                                                                )
                                                            "
                                                        >
                                                            TL
                                                        </v-btn>
                                                    </template>
                                                    <span>{{
                                                        rowCe.approve_status
                                                            .head_date
                                                    }}</span>
                                                </v-tooltip>

                                                <v-tooltip top>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                        }"
                                                    >
                                                        <v-btn
                                                            v-on="on"
                                                            small
                                                            :color="
                                                                chk_approve_color(
                                                                    rowCe
                                                                        .approve_status
                                                                        .requested_status,
                                                                    2,
                                                                    rowCe
                                                                        .approve_status
                                                                        .mgr_status
                                                                )
                                                            "
                                                        >
                                                            MGR
                                                        </v-btn>
                                                    </template>
                                                    <span>{{
                                                        rowCe.approve_status
                                                            .mgr_date
                                                    }}</span>
                                                </v-tooltip>

                                                <v-tooltip top>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                        }"
                                                    >
                                                        <v-btn
                                                            v-on="on"
                                                            small
                                                            :color="
                                                                chk_approve_color(
                                                                    rowCe
                                                                        .approve_status
                                                                        .requested_status,
                                                                    3,
                                                                    rowCe
                                                                        .approve_status
                                                                        .md_status
                                                                )
                                                            "
                                                        >
                                                            MD
                                                        </v-btn>
                                                    </template>
                                                    <span>
                                                        {{
                                                            rowCe.approve_status
                                                                .md_date
                                                        }}
                                                    </span>
                                                </v-tooltip>
                                            </v-btn-toggle>
                                        </td>
                                        <td class="text-center">
                                            <v-btn
                                                x-small
                                                color="white"
                                                class="primary--text ml-1 mr-1"
                                                fab
                                                v-if="
                                                    rowCe.approve_status
                                                        .requested_status !=
                                                        null
                                                "
                                                @click="
                                                    get_dialogLogOT(
                                                        rowCe.emp_id
                                                    )
                                                "
                                            >
                                                <v-icon small
                                                    >mdi-magnify</v-icon
                                                >
                                            </v-btn>
                                            <v-btn fab x-small>
                                                <v-icon
                                                    @click="print(rowCe.emp_id)"
                                                    small
                                                    color="teal"
                                                    >mdi-printer</v-icon
                                                >
                                            </v-btn>
                                        </td>
                                    </tr>
                                    <br />
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card>
        </div>
        <!-- END MAIN -->

        <div id="printDiv" v-if="chk_print == true">
            <v-row>
                <v-col cols="6">
                    <img
                        src="../../assets/all/acacia_certified_new.png"
                        alt="guide marker"
                        width="70%"
                    />
                </v-col>
                <v-col cols="6" class="text-right" align-self="center">
                    <b>{{ data_print.paycode.name }}</b>
                </v-col>
            </v-row>
            <table width="100%" style="margin-top:10px; font-size:11px;">
                <tr align="center">
                    <td colspan="8">
                        <span align="center" style="font-size: 17px;"
                            >OVER TIME REPORT</span
                        >
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td colspan="2" align="right">Month Ending :</td>
                    <td
                        colspan="4"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        {{ data_print.paycode.period }}
                    </td>
                    <td></td>
                </tr>

                <tr>
                    <td width="5%" align="right">Name :</td>
                    <td
                        width="19%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        {{ data_print.engineer.engineer_name }}
                    </td>
                    <td width="10%" align="right">Employee No :</td>
                    <td
                        width="10%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        {{ data_print.engineer.emp_id }}
                    </td>
                    <td width="10%" align="right">Position :</td>
                    <td
                        width="15%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        {{ data_print.engineer.position_name }}
                    </td>
                    <td width="10%" align="right">Company :</td>
                    <td
                        width="15%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        Acacia IT Services
                    </td>
                </tr>
            </table>

            <table width="100%" style="margin-top:2px; font-size:11px;">
                <tr>
                    <td width="16.6%" align="right">Normal Waiting Time :</td>
                    <td
                        width="19.6%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        08.30 - 17.30
                    </td>
                    <td width="10%" align="right">Cost Center :</td>
                    <td
                        width="22.6%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        {{ data_print.engineer.cost_center_name }}
                    </td>
                    <td width="13.6%" align="right">Telephone No :</td>
                    <td
                        width="16.6%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        {{ data_print.engineer.phone }}
                    </td>
                </tr>
            </table>

            <table
                width="100%"
                border="1"
                style="margin-top:25px; font-size:11px;"
            >
                <thead>
                    <tr>
                        <td class="text-center" rowspan="2" width="5%">Date</td>
                        <td class="text-center" rowspan="2" width="3%">
                            Week<br />Day
                        </td>
                        <td class="text-center" rowspan="2" width="10%">
                            Log No.<br />Case No.
                        </td>
                        <td class="text-center" rowspan="2" width="13%">
                            Customer's name
                        </td>
                        <td class="text-center" rowspan="2" width="20%">
                            Job to be done<br />Justification
                        </td>
                        <td class="text-center" rowspan="2" width="5%">ATT</td>
                        <td class="text-center" colspan="2" width="11%">
                            Overtime Period
                        </td>
                        <td class="text-center" colspan="3" width="11%">
                            Rate Overtime(Hrs.)
                        </td>
                        <td class="text-center" rowspan="2" width="5%">
                            Standby<br />(Y/N)
                        </td>
                        <td class="text-center" rowspan="2" width="17%">
                            Remark
                        </td>
                    </tr>
                    <tr>
                        <td class="text-center">Start</td>
                        <td class="text-center">End</td>
                        <td class="text-center">X1.0</td>
                        <td class="text-center">X1.5</td>
                        <td class="text-center">X3.0</td>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(row, index) in data_print.detail"
                        :key="index"
                        :style="
                            row.weekday == 'Sat' || row.weekday == 'Sun'
                                ? 'background-color: #e0e0e0;'
                                : ''
                        "
                    >
                        <td class="text-center">{{ row.onsite_date }}</td>
                        <td class="text-center">{{ row.weekday }}</td>
                        <td>{{ row.case_id }}</td>
                        <td>{{ row.site_name }}</td>
                        <td>{{ row.solution }}</td>
                        <td>{{ row.att }}</td>
                        <td class="text-center">{{ row.start }}</td>
                        <td class="text-center">{{ row.stop }}</td>
                        <td class="text-center">{{ row.x10 }}</td>
                        <td class="text-center">{{ row.x15 }}</td>
                        <td class="text-center">{{ row.x30 }}</td>
                        <td></td>
                        <td>{{ row.remark }}</td>
                    </tr>
                    <tr>
                        <td colspan="7"></td>
                        <td><b>Total</b></td>
                        <td class="text-center">
                            <b>{{ data_print.sum.x10 }}</b>
                        </td>
                        <td class="text-center">
                            <b>{{ data_print.sum.x15 }}</b>
                        </td>
                        <td class="text-center">
                            <b>{{ data_print.sum.x30 }}</b>
                        </td>
                        <td colspan="2"></td>
                    </tr>
                </tbody>
            </table>
            <table width="100%" style="margin-top:20px; font-size:11px;">
                <tr>
                    <td width="17%" align="right">Employee's signature :</td>
                    <td
                        width="18%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        {{ data_print.approve_status.requested_name }}
                    </td>
                    <td width="5%" align="right">Date :</td>
                    <td
                        width="10%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        {{ data_print.approve_status.requested_date }}
                    </td>
                    <td width="17%" align="right">Approve's signatur :</td>
                    <td
                        width="18%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        {{ data_print.approve_status.head_name }}
                    </td>
                    <td width="5%" align="right">Date :</td>
                    <td
                        width="10%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        {{ data_print.approve_status.head_date }}
                    </td>
                </tr>
                <tr>
                    <td width="17%" align="right">Approve's signature :</td>
                    <td
                        width="18%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        {{ data_print.approve_status.mgr_name }}
                    </td>
                    <td width="5%" align="right">Date :</td>
                    <td
                        width="10%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        {{ data_print.approve_status.mgr_date }}
                    </td>
                    <td width="17%" align="right">Approve's signatur :</td>
                    <td
                        width="18%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        {{ data_print.approve_status.md_name }}
                    </td>
                    <td width="5%" align="right">Date :</td>
                    <td
                        width="10%"
                        style="border-bottom: 1px solid #000;"
                        align="center"
                    >
                        {{ data_print.approve_status.md_date }}
                    </td>
                </tr>
            </table>
        </div>

        <v-dialog v-model="dialog" class="mx-auto" max-width="375">
            <v-card>
                <v-card-text>
                    <div v-if="chk_member == true">
                        <br />
                        <v-progress-linear
                            color="orange accent-4"
                            indeterminate
                        ></v-progress-linear>
                    </div>

                    <div v-if="chk_member == false">
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <img
                                    :src="url_pic + member.img"
                                    :alt="member.name"
                                    width="50%"
                                />
                            </v-col>
                            <v-col cols="12" class="mar-t-20 text-center">
                                <span class="fix-das-bb">{{
                                    member.name
                                }}</span>
                                <br />
                                {{ member.team }}
                            </v-col>

                            <v-col cols="12" class="text-center mar-t-10">
                                <div
                                    v-for="(row_e, index_e) in member.data"
                                    :key="index_e"
                                >
                                    <v-list-item class="mar-t-10">
                                        <v-list-item-title class="text-center">
                                            <span class="fix-das-bb">{{
                                                row_e.paycode
                                            }}</span>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item class="mar-t-20">
                                        <v-list-item-subtitle
                                            class="text-center"
                                        >
                                            <v-chip small>{{
                                                "x1.0 : " + row_e.x10
                                            }}</v-chip>
                                            <v-chip small class="ml-2 mr-2">{{
                                                "x1.5 : " + row_e.x15
                                            }}</v-chip>
                                            <v-chip small>{{
                                                "x3.0 : " + row_e.x30
                                            }}</v-chip>
                                        </v-list-item-subtitle>
                                    </v-list-item>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>

                <v-divider v-if="chk_member == false"></v-divider>

                <v-card-actions v-if="chk_member == false">
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        class="btn-detail mt-1 mb-1"
                        text
                        @click="func_approve()"
                    >
                        View More
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogLogOT" width="500">
            <OtLog :emp_id="emp_id" />
        </v-dialog>

        <back-to-top bottom="50px" right="50px">
            <v-btn small fab color="deep-purple lighten-2">
                <v-icon style="color:#FFF">mdi-chevron-up</v-icon>
            </v-btn>
        </back-to-top>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import OtLog from "../Onsite/components/OTLog"

let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    components: {
        OtLog,
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
    },
    props: ["data_ScheduleCase"],
    methods: {
        async get_data() {
            await axios
                .get(url + "ot-approve", this.tk)
                .then((response) => {
                    // console.log(response.data)
                    this.data_main = response.data
                    this.paycode = response.data.paycode
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        chk_approve_color(st, n, st2) {
            if (n === 1) {
                if (st === "request") {
                    return "yellow darken-1 white--text"
                } else if (st === "head approve" || st2 === "approve") {
                    return "green accent-3 white--text"
                } else if (st2 === "not approve") {
                    return "red accent-2 white--text"
                } else {
                    return "blue-grey darken-2 white--text"
                }
            } else if (n === 2) {
                if (st === "head approve") {
                    return "yellow darken-1 white--text"
                } else if (st === "mgr approve" || st2 === "approve") {
                    return "green accent-3 white--text"
                } else if (st2 === "not approve") {
                    return "red accent-2 white--text"
                } else {
                    return "blue-grey darken-2 white--text"
                }
            } else if (n === 3) {
                if (st === "mgr approve") {
                    return "yellow darken-1 white--text"
                } else if (st === "md approve" || st2 === "approve") {
                    return "green accent-3 white--text"
                } else if (st2 === "not approve") {
                    return "red accent-2 white--text"
                } else {
                    return "blue-grey darken-2 white--text"
                }
            }
        },
        async view_emp(empId, name, s_name) {
            this.dialog = true
            this.chk_member = true
            this.emp_id = empId
            this.member.name = name + " " + s_name

            await axios
                .get(url + "ot-approve/view-detail/" + this.emp_id)
                .then((response) => {
                    this.chk_member = false
                    this.member.img = response.data.file_store_name
                    this.member.team = response.data.team_name
                    this.member.data = response.data.expenses
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        func_approve() {
            // this.$root.$router.push({
            //     path: "/OT/" + this.emp_id,
            // })

            let routeData = this.$router.resolve({
                path: "/OT/" + this.emp_id,
                query: { p: this.paycode },
            })
            window.open(routeData.href, "_blank")
        },
        get_dialogLogOT(empId) {
            this.emp_id = empId
            this.dialogLogOT = true
        },
        async export_data() {
            this.chk_export_data = true
            await axios({
                url: url + "ot-export",
                method: "GET",
                responseType: "blob",
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.chk_export_data = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "file.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
        async print(emp_id) {
            await axios
                .get(url + "ot/print/" + emp_id, this.tk)
                .then((response) => {
                    this.data_print = response.data
                    this.chk_print = true

                    const localOptions = {
                        styles: [
                            "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                            "https://aitt.netlify.app/landscape.css",
                        ],
                    }
                    setTimeout(() => {
                        this.$htmlToPaper("printDiv")
                        this.chk_print = false
                    }, 700)
                })
                .catch((error) => {
                    console.log(error)
                })
        },
    },
    data() {
        return {
            tk: null,
            data_main: [],
            team_name: localStorage.team_name,
            url_pic: `${process.env.VUE_APP_ROOT_API}/api/profile_img/`,
            dialog: false,
            emp_id: null,
            chk_member: false,
            member: {
                name: null,
                team: null,
                img: null,
                data: [],
            },
            dialogLogOT: false,
            chk_export_data: false,
            chk_print: false,
            data_print: [],
            paycode: "",
        }
    },
}
</script>
<style scoped>
.fix-das-aa {
    color: rgb(52, 68, 109) !important;
    font-size: 14px;
    /* font-weight: bold; */
}
.fix-das-bb {
    color: rgb(52, 68, 109) !important;
    font-size: 17px;
    font-weight: bold;
}

.mar-t-13 {
    margin-top: -13px !important;
}
.fix-h-province {
    background-color: #0c374e;
    border-radius: 4px;
    /* margin-left: 10px; */
    margin-bottom: 3px;
    margin-top: 10px;
    font-weight: bold;
    color: #fffb00;
}
.fix-border-expense-b {
    /* border-left: 1px solid #85d1d4; */
    border-right: 2px solid #85d1d4;
}
.fix-font-h1 {
    color: #0d465d;
    font-weight: 900;
}
.fix-font-h2 {
    color: #ffffff;
    font-weight: 900;
}
.color-f {
    color: #ffffff !important;
}

.color-1 {
    color: #00ff3b;
}

.fix-p {
    background-color: #fff !important;
    border-radius: 10px;
}
.btn-detail2 {
    font-size: 14px;
    font-weight: bold;
    color: #3e6d87;
    background-color: #fff;
}
.btn-detail2:hover {
    color: #fffb00 !important;
    background-color: #0c374e !important;
}
.btn-detail {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #3e6d87;
}
.btn-detail:hover {
    color: #fffb00 !important;
    background-color: #0c374e !important;
}
.btn-view-m-2 {
    color: #01152c;
}
.btn-view-m-2:hover {
    color: #9ac6f0;
    background-color: #326586;
}

.fix-font-ea {
    color: #fff;
    font-weight: bold;
}
.fix-font-1ea {
    color: #36fabf;
    font-weight: bold;
}
.fix-font-2ea {
    color: #f1cf38;
    font-weight: bold;
}
.fix-font-3ea {
    color: #00ff3b;
    font-weight: bold;
}
</style>
